import USER_TYPE_CONFIG from "Explore/Config/userTypeConfig";
import { useSelector } from "react-redux";

const useAuth = ({ entityType } = {}) => {
  const user = useSelector((state) => state.user);
  const userRole = user?.data?.role || "guest";

  const getUserTypeConfigByEntityType = (entityType) => {
    if (!entityType) return null;
    return USER_TYPE_CONFIG[entityType][userRole];
  };

  return {
    user: user?.data,
    isAuthLoading: user?.isLoading,
    userRole,
    getUserTypeConfigByEntityType,
    userTypeConfig: getUserTypeConfigByEntityType(entityType),
  };
};

export default useAuth;
